<template>
  <div class="uk-margin-medium-top" :class="role" v-bind:data-uk-accordion="enableAccording">
    <!--чат-->
    <div style="border: 1px solid #F0F0F0">
      <!--заголовок чата-->
      <template v-if="enableAccording">
        <a href class="uk-padding-small tm-background-muted uk-accordion-title tm-chat-accordion-title">
          <div class="uk-grid uk-grid-small uk-flex-middle">
            <div class="uk-text-uppercase">
              {{local_page_keys.label_order_history}}:
            </div>
          </div>
        </a>
      </template>
      <template v-else>
        <div class="uk-padding-xsmall tm-background-muted 3">
          <div class="uk-grid uk-grid-small uk-flex-middle">
            <div class="uk-text-uppercase">
              {{local_page_keys.label_order_history}}:
            </div>
          </div>
        </div>
      </template>
      <!--блок чата-->
      <div :class="{'uk-accordion-content': enableAccording}" id="uk-accordion-content-block" class="uk-margin-remove">
        <div class="tm-chat-box uk-panel-scrollable chat_scroll_panel 1" id="chat_scroll_panel">
          <ul class="tm-chat-box-list">
            <template v-for="(message, index) of order_chat_divided">
              <template v-if="!(!messageIsEmpty(message) && message.role === 'retoucher' && role === 'retoucher' && user !== message.email && !message.link_text)">
                <!--дата-разделитель-->
                <li v-if="isMessageDivider(message)" :key="(message.index? message.index: index)+'_divider'" class="tm-chat-box-date-divider-li">
                  <div class="tm-chat-box-date-divider uk-text-center uk-text-muted">{{ message.date_divider }}</div>
                </li>
                <!--строка сообщения-->
                <li v-if="!messageIsEmpty(message)" :key="(message.index? message.index: index)" :class="'tm-chat-box-mess-' + getClass(message.email)">
                  <template>
                    <div class="uk-grid uk-grid-collapse uk-flex-bottom tm-chat-box-mess-line" :class="getClass(message.email)" data-uk-grid>
                      <!--иконка участника чата-->
                      <div class="uk-width-auto tm-chat-box-avatar" v-if="user && message.email !== user" :class="'tm-chat-box-' + message.role">
                        <div class="uk-grid uk-grid-collapse uk-flex-middle" data-uk-grid>
                          <div class="uk-width-expand">
                            <!--вид для админов-->
                            <div class="tm-chat-box-name tm-chat-box-for-admin"
                                 :style="'background-color: #' + getColor(message.email)"
                                 :data-uk-tooltip="message.role + ' ' + message.name"
                                 v-if="!(role == 'retoucher' || role == 'junior-retoucher')">
                              <!--для всех кроме ретушера и джуниора-->
                              <span v-if="message.name === 'redo client'">
                              C
                            </span>
                            <span v-if="message.role === 'senior-retoucher'">
                              {{ (message.role)[0] }}
                            </span>
                            <span v-else>
                              {{ getNumberFromEmail(message.name, message.role) }}
                            </span>
                          </div>
                          <!--вид для ретушеров-->
                          <div class="tm-chat-box-name"
                               :style="'background-color: #' + getColor(message.email)"
                               v-else>
                            <!--для ретушера и джуниора-->
                            <span v-if="message.name === 'redo client'">
                              C
                            </span>
                            <span v-else>
                              {{ (message.role)[0] }}
                            </span>
                          </div>
                        </div>
                        <!--чекбокс определения адресата комента-->
                        <div v-if="role === 'senior-retoucher'" class="uk-width-auto" style="margin-left: 5px;">
                          <!--выбор проверяющего-->
                          <input
                            v-if="message.role === 'pro-retoucher' || ( message.role === 'admin' && message.name !== 'redo client') "
                            @click="toggleProRetoucherForComment(message.email, index)"
                            class="uk-checkbox 1"
                            type="checkbox"
                            :disabled="isProRetoucherSelected(index)">
                          <!--выбор ретушера-->
                          <input
                            v-else-if="message.role === 'retoucher'"
                            @click="toggleRetoucherForComment(message, index)"
                            class="uk-checkbox 2"
                            type="checkbox"
                            :disabled="isRetoucherSelected(index)">
                        </div>
                      </div>
                    </div>
                      <!--сообщение участника чата-->
                      <div class="uk-width-expand">
                        <div class="tm-chat-box-line" :class="{'tm-chat-box-line-error': message.functionRatings && !isValidateProRetoucherRating}">
                          <div>
                            <div class="uk-grid uk-grid-collapse" data-uk-grid>
                              <div class="uk-width-expand">
                                <div class="tm-chat-box-text">
                                  <!--цветные заметки-->
                                  <div class="tm-chat-box-notes">
                                    <div v-if="(message.red_note !== '')" class="red-note tm-chat-box-note">
                                      {{ message.red_note }}
                                    </div>
                                    <div v-if="(message.green_note !== '')" class="green-note tm-chat-box-note">
                                      {{ message.green_note }}
                                    </div>
                                    <div v-if="(message.blue_note !== '')" class="blue-note tm-chat-box-note">
                                      {{ message.blue_note }}
                                    </div>
                                    <div v-if="(message.black_note !== '')" class="black-note tm-chat-box-note">
                                      {{ message.black_note }}
                                    </div>
                                    <div v-if="(message.orange_note !== '')" class="orange-note tm-chat-box-note">
                                      {{ message.orange_note }}
                                    </div>
                                  </div>

                                  <!--Замечания от senior-->
                                  <div class="tm-chat-box-mess" v-if="(message.status_rejected !== '')">
                                    <b>{{ filterMessageStatusRejected(message.status_rejected) }}</b>
                                  </div>

                                  <!--сообщение для 1 заказа после нажатия В РАБОТУ-->
                                  <div class="tm-chat-box-mess" v-if="(message.give_it_to_work && message.give_it_to_work !== '')">
                                    {{ local_page_keys.give_it_to_work }}
                                  </div>

                                  <!--сообщение-->
                                  <div class="tm-chat-box-mess" v-if="message.text">
                                    <p v-for='item in message.text.split("\r")' :key="item">
                                      <span v-html="prepareText(item)"></span>
                                      <span class="material-icons tm-translate-button" v-if="item && item.length > 0 && !languageRuDetect(item)" @click="openGoogleTranslate(item)">translate</span>
                                    </p>
                                  </div>

                                  <!--Принято пояснение от проверяющего-->
                                  <div class="tm-chat-box-mess" v-if="(message.accepted_from_inspector === true)">
                                    <b> {{ local_page_keys.accepted_from_inspector }}</b>
                                  </div>

                                  <!--Халтурная работа-->
                                  <div v-if="!(role == 'retoucher' || role == 'junior-retoucher')">
                                    <div class="tm-chat-box-mess" v-if="(message.sloppy_work === true)">
                                      <b> {{ local_page_keys.sloppy_work_chat_text }} 10%</b>
                                    </div>
                                  </div>

                                  <!--Комментарий от про-ретушера-->
                                  <div class="tm-chat-box-mess" v-if="(message.pro_retoucher_comment !== '')">
                                    {{ message.pro_retoucher_comment }}
                                    <span class="material-icons tm-translate-button"
                                          v-if="message.pro_retoucher_comment && message.pro_retoucher_comment.length > 0 && !languageRuDetect(message.pro_retoucher_comment)"
                                          @click="openGoogleTranslate(message.pro_retoucher_comment)">translate</span>
                                  </div>

                                  <!--ссылки на файл или зону-->
                                  <div class="tm-chat-box-file" v-if="message.link_anchor !== '' && message.link_text !== ''">
                                    <!--ЗОНА-->
                                    <template v-if="message.role ==='senior-retoucher' || message.role === 'pro-retoucher'  || message.role === 'admin'">
                                      <a
                                          class="tm-chat-box-file1"
                                          href="#"
                                          @click.prevent="showFixAdmin(message)"
                                          @mousemove="zonephoto(message.link_text)"
                                          @mouseleave="zonephotoLeave()">
                                        {{ message.link_anchor }}
                                      </a>
                                    </template>
                                    <template
                                        v-else-if=" message.role ==='' && message.name === 'redo client'">
                                      <a
                                          class="tm-chat-box-file1"
                                          href="#"
                                          @click.prevent="showFixAdmin(message)"
                                          @mousemove="zonephoto(message.link_text, true)"
                                          @mouseleave="zonephotoLeave()">
                                        {{ message.link_anchor }}
                                      </a>
                                    </template>
                                    <!--ФАЙЛ-->
                                    <template
                                        v-else-if="typeof order_photo_after_last_not_education == 'number' && order_photo_after_last_not_education >= getAfterPhotoVerNumber(message.link_text_non_secure)">
                                      <a
                                          class="tm-chat-box-file2 1"
                                          @mousemove="zonephoto(message.link_text)"
                                          @mouseleave="zonephotoLeave()">
                                        {{ local_page_keys.label_version }} {{ getAfterPhotoVerNumber(message.link_text_non_secure) }}
                                      </a>
                                    </template>
                                    <template v-else>
                                      <!--версия-->
                                      <a
                                          class="tm-chat-box-file2 2"
                                          href="#"
                                          @mousemove="zonephoto(message.link_text)"
                                          @mouseleave="zonephotoLeave()"
                                          @click.prevent="photoDownload(message.link_text)">
                                        {{ local_page_keys.label_version }} {{ getAfterPhotoVerNumber(message.link_text_non_secure) }}
                                      </a>
                                      <div v-if="message.version && message.version_records && allowedForViewingByRole"
                                           class="uk-display-inline-block uk-margin-xsmall-left"
                                           :data-uk-tooltip="'pos: right; title: ' + local_page_keys['client_viewed_version'] +' #' + message.version +'</br>' + getDatesOfViewedVersion(message.version_records)"
                                           style="cursor: pointer;">
                                        <md-icon>visibility</md-icon>
                                      </div>
                                      <!--Опрос в ТГ канале-->
                                      <div v-if="message.votedInfo"  class="uk-display-inline-block uk-margin-xsmall-left">
                                        <a :href="message.votedInfo.vote_link" target="_blank" class="" :data-uk-tooltip="'pos: right; title: ' + local_page_keys.vote_is_create + ' ' + message.votedInfo.voted_at">
                                          <md-icon>checklist</md-icon>
                                        </a>
                                      </div>
                                      <!--Для проретушера показ валидации загруженных after фото-->
                                      <template v-if="message.warnings && !message.warnings.status">
                                        <div class="tm-chat-version-warning" v-for="(message,indexMessage) of message.warnings.message" :key="indexMessage">
                                          <div v-html="message"></div>
                                        </div>
                                      </template>
                                      <!--оцененные версии-->
                                      <div v-if="allowedForViewingByRole" class="uk-position-top-right tm-chat-version-graded" style="margin-right: 35px;">
                                        <div style="padding: 6px;font-weight: 300;">
                                          <div class="uk-grid tm-grid-xsmall uk-flex-middle" data-uk-grid>
                                            <div v-for="(userRate, userKey) in message.functionAllRatings" :key="userKey">
                                              <div>
                                                <div class="tm-chat-box-name tm-chat-box-name-smaller" :style="'background-color: #' + getColor(userRate.email)">
                                                  <span>{{ getNumberFromEmail(userRate.email, userKey) }}</span>
                                                </div>
                                              </div>
                                              <div style="width:350px" class="uk-dropdown tm-dropdown" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 400; delay-show: 0; offset: 5">
                                                <div>
                                                  <div>
                                                    {{ userRate.email }}
                                                  </div>
                                                  <hr class="uk-margin-small">
                                                  <div v-for="(value,index) of Object.keys(faces)" :key="index">
                                                    <div v-for="(faceValue, key) of  Object.keys(faces[value])" :key="key">
                                                      <div v-if="faceValue != 'order_super_function' && faceValue != 'order_silver_super_function' && faceValue != 'order_subscription_super_function' && faces[value][faceValue].RU">
                                                        <div class="uk-grid tm-grid-xsmall uk-flex-middle tm-text-small uk-margin-small-top" data-uk-grid>
                                                          <div class="uk-width-auto">
                                                            <div class="tm-function-order-num">{{ key + 1}} </div>
                                                          </div>
                                                          <div class="uk-width-expand uk-text-truncate">
                                                            {{faces[value][faceValue].RU}}
                                                          </div>
                                                          <div v-if="getVersionRateData(userRate,faceValue, value).icon">
                                                            <label class="tm-chat-version-grade-button-label">
                                                              <div class="tm-chat-version-grade-button tm-chat-version-grade-button-checked"
                                                                   :class="'tm-chat-version-grade-button-' + getVersionRateData(userRate,faceValue, value).color"
                                                                   :data-uk-tooltip="getVersionRateData(userRate,faceValue, value).tooltip"
                                                                   :id="'rate_1_order_whiten_teeth_' + key + value">
                                                                <md-icon>{{getVersionRateData(userRate,faceValue, value).icon}}</md-icon>
                                                              </div>
                                                            </label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!--Оценка версии-->
                                      <template v-if="message.allowRate">
                                        <ul class="uk-accordion uk-margin-small-top tm-chat-version-grade " data-uk-accordion>
                                          <li class="uk-open">
                                            <a class="uk-accordion-title uk-link-toggle " href="#">
                                              Оценка версии
                                            </a>
                                            <div class="uk-accordion-content">
                                              <!--список функций-->
                                              <div class="uk-grid uk-child-width-1-1 tm-grid-xsmall" data-uk-grid>
                                                <!--функции-->
                                                <div v-for="(value,index) of Object.keys(faces)" :key="index">
                                                  <div v-for="(faceValue, key) of  Object.keys(faces[value])" :key="key">
                                                    <div v-if="faceValue != 'order_super_function' && faceValue != 'order_silver_super_function' && faceValue != 'order_subscription_super_function' && faces[value][faceValue].RU">
                                                      <!--название-->
                                                      <div :class="{'tm-function-order-error' : !validateFace(faceValue + '_' + value ) } ">
                                                        <div class="uk-grid tm-grid-xsmall uk-flex-middle tm-text-small " data-uk-grid>
                                                          <div class="uk-width-auto ">
                                                            <div class="tm-function-order-num">{{ key + 1 }}</div>
                                                          </div>
                                                          <div class="uk-width-expand">
                                                            {{faces[value][faceValue].RU}}
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!--оценка-->
                                                      <div class="uk-margin-xsmall">
                                                        <div class="uk-grid tm-grid-xsmall  uk-flex-middle uk-text-center tm-chat-version-grade-grid" :class=" 'uk-child-width-1-' + fieldsRatingsBlockData.length " data-uk-grid>
                                                          <div v-for="(field, fieldKey) in fieldsRatingsBlockData" :key="fieldKey">
                                                            <label class="tm-chat-version-grade-button-label ">
                                                              <div class="tm-chat-version-grade-button"
                                                                   :data-uk-tooltip="field.tooltip"
                                                                   :id="'rate_'+ field.rate + '_' + faceValue + '_' + value  + '_'+ getAfterPhotoVerNumber(message.link_text_non_secure)"
                                                                   :class="getVersionRateClass(field.rate,message,faceValue,value)"
                                                                   @click="saveVersionRating(field.rate,message,faceValue,value)">
                                                                <md-icon>{{field.icon}}</md-icon>
                                                              </div>
                                                            </label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      </template>
                                    </template>
                                  </div>
                                </div>
                              </div>
                              <!--копирование сообщения в буфер-->
                              <div v-if="['senior-retoucher','pro-retoucher','admin','mini-admin'].indexOf(role) > -1 && message.text && message.role && message.role !== 'retoucher'"
                                   class="uk-width-auto uk-margin-small-left"
                                   style="cursor: pointer;"
                                   data-uk-tooltip="title:Copy message; pos: top"
                                   @click="copyMessage($event,message)">
                                <md-icon>content_copy</md-icon>
                              </div>
                            </div>
                            <!--дата-->
                            <div class="tm-chat-box-time" :data-uk-tooltip="message.time + ' / ' + message.date">
                              {{ formatTime(message.time) }}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </template>
                </li>
                <!--пустые сообщения только для сеньера и про-ретушера, а также если просмотр со страници рейтинга-->
                <li v-if=" (messageIsEmpty(message) &&  ( (role=='senior-retoucher' || role=='pro-retoucher' || role=='admin' || role=='mini-admin') || isFromRetocherProgressReport ) && !isMessageLike(message))"
                  :key="(message.index? message.index: index)"
                  :class="'tm-chat-box-mess-' + getClass(message.email)">
                <template>
                  <div class="uk-grid uk-grid-collapse uk-flex-bottom tm-chat-box-mess-line" :class="getClass(message.email)" data-uk-grid>
                    <!--иконка участника чата-->
                    <div class="uk-width-auto tm-chat-box-avatar" v-if="user && message.email !== user" :class="'tm-chat-box-' + message.role">
                      <div class="uk-grid uk-grid-collapse uk-flex-middle" data-uk-grid>
                        <div class="uk-width-expand">
                          <!--вид для админов-->
                          <div class="tm-chat-box-name tm-chat-box-for-admin"
                               :style="'background-color: #' + getColor(message.email)"
                               :data-uk-tooltip="message.role + ' ' + message.name"
                               v-if="!(role == 'retoucher' || role == 'junior-retoucher')">
                            <!--для все кроме ретушера и джуниора-->
                            <span v-if="message.name === 'redo client'">
                          C
                        </span>
                            <span v-else>
                          {{ getNumberFromEmail(message.name, message.role) }}
                        </span>
                          </div>
                          <!--вид для ретушеров-->
                          <div class="tm-chat-box-name" :style="'background-color: #' + getColor(message.email)" v-else>
                            <!--для ретушера и джуниора-->
                            <span v-if="message.name === 'redo client'">
                          C
                        </span>
                            <span v-else>
                          {{ (message.role)[0] }}
                        </span>
                          </div>
                        </div>
                        <!--чекбокс определения адресата комента-->
                        <div v-if="role === 'senior-retoucher'" class="uk-width-auto" style="margin-left: 5px;">
                          <!--выбор проверяющего-->
                          <input
                              v-if="message.role === 'pro-retoucher' || ( message.role === 'admin' && message.name !== 'redo client') "
                              @click="toggleProRetoucherForComment(message.email, index)"
                              class="uk-checkbox 3"
                              type="checkbox"
                              :disabled="isProRetoucherSelected(index)">
                          <!--выбор ретушера-->
                          <input v-else-if="message.role === 'retoucher'"
                                 @click="toggleRetoucherForComment(message, index)"
                                 class="uk-checkbox 4"
                                 type="checkbox"
                                 :disabled="isRetoucherSelected(index)">
                        </div>
                      </div>
                    </div>
                    <!--сообщение-->
                    <div class="uk-width-expand">
                      <div class="tm-chat-box-line">
                        <div>
                          <div class="tm-chat-box-text">
                            <!--Халтурная работа при пустом комментарии-->
                            <div class="tm-chat-box-mess" v-if="message.role === 'senior-retoucher' && message.sloppy_work === true">
                              <b> {{ local_page_keys.sloppy_work_chat_text }} 10%</b>
                            </div>
                            <div v-else-if="message.order_created">
                                <div class="tm-chat-box-mess" style="font-weight: 100">
                                  {{local_page_keys.order_created}}: {{message.order_created}}
                               </div>
                            </div>
                            <div v-else class="tm-chat-box-mess">
                              {{ local_page_keys.done_admin_message_chat }}
                            </div>
                          </div>
                          <!--дата-->
                          <div class="tm-chat-box-time" :data-uk-tooltip="message.time + ' / ' + message.date">
                            {{ formatTime(message.time) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </li>
                <!--сообщения содержащие ОЦЕНКУ клиентом-->
                <li v-if="isMessageLike(message) && getLike(message.like_by_client)"
                  :key="(message.index? message.index: index)"
                  :class="'tm-chat-box-mess-' + getClass(message.email)">
                <template>
                  <div class="uk-grid uk-grid-collapse uk-flex-bottom tm-chat-box-mess-line" :class="getClass(message.email)" data-uk-grid>
                    <!--иконка участника чата-->
                    <div class="uk-width-auto tm-chat-box-avatar" :class="'tm-chat-box-admin'">
                      <!--вид для админов-->
                      <div class="tm-chat-box-name tm-chat-box-for-admin"
                           :style="'background-color: #' + getColor(message.email)"
                           :data-uk-tooltip="message.name">
                        <span>
                          C
                        </span>
                      </div>
                    </div>
                    <!--сообщение участника чата-->
                    <div class="uk-width-expand">
                      <div class="tm-chat-box-line">
                        <div>
                          <div class="tm-chat-box-text">
                            <div class="tm-chat-box-mess likes">
                              <span class="likes-gold">{{ "★".repeat( getLike(message.like_by_client)) }}</span><span class="likes-grey">{{ "★".repeat(5-getLike(message.like_by_client)) }}</span>
                            </div>
                          </div>
                          <div class="tm-chat-box-time" :data-uk-tooltip="message.time + ' / ' + message.date">
                            {{ formatTime(message.time) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </li>
              </template>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <!--диалоговое окно замечаний проверяющего-->
    <md-dialog
        class="tm-check-dialog"
        :md-active.sync="showDialog1"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#"
           class="uk-position-top-right tm-dialog-close"
           @click.prevent="closeDialogFix">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-grid uk-flex-middle_">
          <!--левая часть-->
          <div class="uk-width-1-2">
            <div class="uk-position-relative">
              <div class="uk-grid uk-grid-collapse uk-flex-middle">
                <div class="tm-block-img uk-text-center">
                  <div class="uk-inline-clip uk-transition-toggle left-part-main-photo main-photo-dialog">
<!--                        <img :src="fixedphoto" alt="" class="left-part-main-photo main-photo-image">-->
                    <preloader :is-visible="zoomLoading" style="position: absolute" class="left-part-main-photo main-photo-image"></preloader>
                    <inner-image-zoom
                        :src="fixedphoto"
                        :zoomSrc="fixedphoto_zoomed_computed"
                        :zoomPreload="true"
                        :className="fixedphoto_zoomed"
                        :afterZoomIn="afterZoomInMethod('fixedphoto_zoomed')"
                        moveType="drag"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-margin-small" >
              <ul class="uk-subnav uk-subnav-pill 1uk-flex-center tm-subnav-small">
                <template v-for="level in zoomLevels">
                  <li :class="level === zoomLevel ? 'uk-active': ''" :key="level">
                    <a @click="setZoomLevel(level)">{{ level + 'x' }}</a>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <!--правая часть-->
          <div class="uk-width-expand">
            <!--статус-->
            <div v-if="rejectedLevel !== ''" class="uk-grid uk-grid-small uk-flex-middle">
              <div>
                {{ local_page_keys.label_done }}:
              </div>
              <div class="uk-text-bold">
                {{ rejectedLevel }}
              </div>
            </div>

            <hr v-if="rejectedLevel !== ''" class="uk-margin-medium">

<!--    список замечаний по отмеченным фукнциям-->
            <div v-if="infoloading">
              <v-progress-circular
                  :width="2"
                  indeterminate
                  style="color: forestgreen"
              ></v-progress-circular>
            </div>
            <div v-else-if="rejectedFunctions !== ''" class="uk-grid uk-grid-collapse uk-child-width-auto uk-margin-top tm-modal-checkbox-list scrollable-dialog 1">
              <div class="uk-margin-small-top checkFunctions"
                   v-for="(face, name) in faces"
                   :key="face.index">
                <div class="check-functions-lables uk-width-1-1 uk-margin-small-bottom" v-if="name === 0">
                  {{ local_page_keys.label_general }}:
                </div>
                <div class="check-functions-lables uk-width-1-1 uk-margin-small-bottom" v-else>
                  {{local_page_keys.label_face}} {{ name }}:
                </div>
                <div v-for="value in face"
                     :key="value.index"
                     class="tm-modal-checkbox-list-item uk-margin-small-bottom"
                     :class="rejFuncClass(value.RU, name)">
                  <div class="tm-modal-checkbox-list-view modal-functions-retoucher_">{{ value.RU }}</div>
                </div>
              </div>
            </div>

            <hr v-if="rejectedFunctions !== ''" class="uk-margin-medium">

            <!--поля цветных комментариев-->
            <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
              <div v-if="blue_reject_note !== null" class="blue">
                <div class="uk-grid uk-grid-small uk-flex-middle">
                  <div>
                    <md-icon class="blue-note">mode_edit</md-icon>
                  </div>
                  <div>
                    {{ blue_reject_note }}
                  </div>
                </div>
              </div>
              <div v-if="red_reject_note !== null" class="red">
                <div class="uk-grid uk-grid-small uk-flex-middle">
                  <div>
                    <md-icon class="red-note">mode_edit</md-icon>
                  </div>
                  <div>
                    {{ red_reject_note }}
                  </div>
                </div>
              </div>
              <div v-if="green_reject_note !== null" class="green">
                <div class="uk-grid uk-grid-small uk-flex-middle">
                  <div>
                    <md-icon class="green-note">mode_edit</md-icon>
                  </div>
                  <div>
                    {{ green_reject_note }}
                  </div>
                </div>
              </div>
              <div v-if="black_reject_note !== null" class="black">
                <div class="uk-grid uk-grid-small uk-flex-middle">
                  <div>
                    <md-icon class="black-note">mode_edit</md-icon>
                  </div>
                  <div>
                    {{ black_reject_note }}
                  </div>
                </div>
              </div>
              <div v-if="orange_reject_note !== null" class="orange">
                <div class="uk-grid uk-grid-small uk-flex-middle">
                  <div>
                    <md-icon class="orange-note">mode_edit</md-icon>
                  </div>
                  <div>
                    {{ orange_reject_note }}
                  </div>
                </div>
              </div>
            </div>

            <hr v-if="rejectedComment !== null" class="uk-margin-medium">

            <!--поле для комментария-->
            <div class="uk-margin-medium-top" v-if="rejectedComment !== null">
              {{ rejectedComment }}
            </div>
          </div>
        </div>
      </div>
    </md-dialog>
    <!--возможно лишнее окно-->
    <md-dialog
        class="tm-gal-dialog"
        :md-active.sync="showDialog10"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click.prevent="showDialog10 = false">
          <span class="material-icons">close</span>
        </a>
        <div class="tm-block-img uk-text-center tm-width-1-1 defore-after-block">
          <img class="alter-photo"
               v-if="modal_photo !== null"
               :src="modal_photo" alt="">
          <img class="alter-photo" v-else src="/img/images.png" alt="">
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import getLocalisationPage from '../../../filters/getLocalisationPage'
import LangMixin from "@/mixins/lang-mixin";
import InnerImageZoom from 'vue-inner-image-zoom';
import Preloader from "@/pages/Dashboard/Components/Preloader";

const logo_colors = [
  "fbd2e2",
  "ffc699",
  "fbf8cb",
  "dbe1bd",
  "93b3a8",
  "a6c6dd",
  "cddafd",
  "f6efff",
  "cca3c1",
  "f9c7ca",
  "dfe9eb",
  "7fadbc",
  "cadbbb",
  "ecdfdd",
  "fce2e3"
];
let activeClass = 'tm-chat-version-grade-button-checked';

export default {
  name: "HistoryBlock",
  props: {
    faces: {
      require: true,
    },
    infoloading: {
      type: Boolean,
      require: false,
    },
    order_id: {
      type: Number,
      require: true,
    },
    order_photo_after_last_not_education: {
      type: Number,
    },
    order_chat: {
      type: Array,
      require: true
    },
    user: {
      type: String,
      require: true
    },
    role: {
      type: String,
      require: true
    },
    enableAccording: {
      type: Boolean,
      default:false
    }

  },
  components: { InnerImageZoom, Preloader},
  mixins: [LangMixin],
  filters: {
    getLocalisationPage
  },
  data: () => ({
    loading: true,
    empty_history: '',
    history_block: Object,
    showDialog1: false,
    fixedphoto: null,
    rejectedLevel: null,
    rejectedFunctions: [],
    rejectedComment: null,
    blue_reject_note: null,
    red_reject_note: null,
    green_reject_note: null,
    black_reject_note: null,
    orange_reject_note: null,
    local_page_keys: {},
    showDialog10: false,
    modal_photo: null,
    emails: [],
    order_chat_divided: [],
    selectedProRetoucherForComment: {
      email: null,
      index: null,
    },
    selectedRetoucherForComment: {
      email: null,
      index: null,
      version: null
    },
    fieldsRatingsBlockData: [],
    fieldsRatingsBlockAllData: [],
    proRetoucherFirstRate:[],
    requiredRateProRetoucher:[],
    isValidateProRetoucherRating:true,
    enableValidate: false,
    zoomLevel: 3,
    zoomLevelOld: 2,
    zoomLevels: [2, 3, 4],
    fixedphoto_zoomed: '',
    observedZoomedElementStyle:'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
    observedZoomedElementStyleOld:'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
    zoomLoading: false,
  }),
  computed: {
    isFromRetocherProgressReport(){
      return this.$route.path === '/new_mvp/retoucherProgressReport';
    },
    allowedForViewingByRole(){
      const allowedRoles = ['retoucher', 'junior-retoucher', 'test-retoucher'];
      return allowedRoles.indexOf(this.role) === -1;
    },
    fixedphoto_zoomed_computed(){
      return this.fixedphoto_zoomed;
    },
  },
  watch: {
    enableAccording: function (newVal, oldVal) {
      var element = document.getElementById('uk-accordion-content-block');
      if (element) {
        if (!newVal && window.getComputedStyle(element).display === 'none') {
          element.style.display = 'block !important';
          element.removeAttribute('hidden');
        } else if (newVal && window.getComputedStyle(element).display === 'block !important') {
          element.style.display = 'none';
        }
      }
    },
    fixedphoto_zoomed_computed:'updateComputedValue',
    zoomFactor: 'updateComputedValue',
  },
  methods: {
    async copyMessage(e, message){
      //console.log(message.text);
      try {
        e.target.classList.add('tm-animation-pulse');
        await navigator.clipboard.writeText(message.text);
        //alert('Copied');
      } catch($e) {
        alert('Cannot copy!!!');
      } finally {
        setTimeout(() => {
          if(e.target.classList.contains('tm-animation-pulse')){
            e.target.classList.remove('tm-animation-pulse');
          }
        }, 1000);

      }
    },
    async toggleProRetoucherForComment(email, index) {
      if (this.selectedProRetoucherForComment.email === email && this.selectedProRetoucherForComment.index === index) {
        this.selectedProRetoucherForComment.email = null;
        this.selectedProRetoucherForComment.index = null;
      } else {
        this.selectedProRetoucherForComment.email = email;
        this.selectedProRetoucherForComment.index = index;
      }
      await  this.$store.dispatch('chat/setSelectedProRetoucher', this.selectedProRetoucherForComment.email);
    },
    async toggleRetoucherForComment(message, index) {
      if (this.selectedRetoucherForComment.email === message.email && this.selectedRetoucherForComment.index === index) {
        this.selectedRetoucherForComment.email = null;
        this.selectedRetoucherForComment.index = null;
        this.selectedRetoucherForComment.version = null;
      } else {
        this.selectedRetoucherForComment.email = message.email;
        this.selectedRetoucherForComment.index = index;
        if ( this.getAfterPhotoVerNumber(message.link_text_non_secure)) {
          this.selectedRetoucherForComment.version = message.link_text_non_secure
        }
      }
      //console.log(this.selectedRetoucherForComment)
      await  this.$store.dispatch('chat/setSelectedRetoucher', this.selectedRetoucherForComment);
    },
    isProRetoucherSelected(index) {
      return this.selectedProRetoucherForComment.index !==null && this.selectedProRetoucherForComment.index !== index;
    },
    isRetoucherSelected(index) {
      return this.selectedRetoucherForComment.index !== null && this.selectedRetoucherForComment.index !== index;
    },
    getAfterPhotoVerNumber(text){
      if(text && typeof text == 'string'){
        const regex = /order_photo_after_(\d+)/;
        const match = text.match(regex);
        const number = match ? match[1] : '';
        return number;
      }
      return '';
    },
    getNumberFromEmail(email,role){
      if(email){

        if(email.match(/(\d+)(?=(.)*@)/) !== null){
          if( email.match(/(\d+)(?=(.)*@)/)[0]){
            return email.match(/(\d+)(?=(.)*@)/)[0];
          }
        }
        return role[0];
      }
      return email;
    },
    zonephoto(url, replace = false) {
      var link = url;
      if (replace) {
        link = this.fixLinkFromClient(link)
      }
      this.$emit('zone_photo', link.replace('dl=0', 'raw=1'));
      this.$emit('zone-visible', true);
      this.$emit('after-visible', false);
    },
    zonephotoLeave() {
      this.$emit('zone_photo', null);
      this.$emit('zone-visible', false);
      this.$emit('after-visible', true);
    },
    photoDownload(url) {
      let url_obj = new URL(url);
      //let path = url_obj.pathname;
      // let searchParams = new URLSearchParams(url);
      // let filename = searchParams.has('fn') ? searchParams.get('fn') : path.split('/').pop();
      // if (url_obj.hostname === 'appfls.fixthephoto.com') { // проблема с CORS
      //   url_obj.hostname = 'fdl.retoucher.app';
      // }

      let searchImage = this.order_chat.find(image => image.link_text === url);
      let filename = searchImage ? searchImage.link_text_non_secure : url;

      fetch(url_obj, { method: 'GET' })
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link); // we need to append the element to the dom -> otherwise it will not work in firefox
            link.click();
            link.remove();  //afterwards we remove the element again
            URL.revokeObjectURL(link.href)
            this.logDownloadFile(filename)
          }).catch(e=>alert(e))
    },
    async logDownloadFile(filename){
      let params = {
        'filename': filename,
        'order_id': this.order_id,
      }
      await  this.$store.dispatch('order/logDownloadFile', params);
    },
    messageIsEmpty(message) {
      let result = true;
      if (message.red_note) {
        result = false;
      } else if (message.green_note) {
        result = false;
      } else if (message.blue_note) {
        result = false;
      } else if (message.black_note) {
        result = false;
      } else if (message.orange_note) {
        result = false;
      } else if (message.status_rejected) {
        result = false;
      } else if (message.functions_rejected) {
        result = false;
      } else if (message.text) {
        result = false;
      } else if (message.link_anchor && message.link_text) {
        result = false;
      } else if (message.give_it_to_work){
        result = false;
      } else if (message.pro_retoucher_comment) {
        result = false;
      }
      return result;
    },
    isMessageDivider(message) {
      let result = false;
      if (message.date_divider) {
        result = true;
      }
      return result;
    },
    isMessageLike(message) {
      let result = false;
      if (message.like_by_client) {
        result = true;
      }
      return result;
    },
    formatTime(time) {
      let timeArray = time.split('-');
      return timeArray[0] + ':' + timeArray[1];
    },
    showFixAdmin(message) {
      this.showDialog1 = true;
      this.fixedphoto = message.link_text;
      this.rejectedLevel = message.status_rejected;
      if (message.text !== '') {
        this.rejectedComment = message.text;
      }
      // if (message.functions_rejected !== '') {
      //   //this.rejectedFunctions = this.getRejectedFunctionsList(message.functions_rejected);
      //   this.rejectedFunctions = JSON.parse(message.functions_rejected);
      // }
      this.blue_reject_note = (message.blue_note !== '' ? message.blue_note : null);
      this.red_reject_note = (message.red_note !== '' ? message.red_note : null);
      this.green_reject_note = (message.green_note !== '' ? message.green_note : null);
      this.black_reject_note = (message.black_note !== '' ? message.black_note : null);
      this.orange_reject_note = (message.orange_note !== '' ? message.orange_note : null);
    },
    closeDialogFix() {
      this.showDialog1 = false;
      this.fixedphoto = null;
      this.rejectedLevel = null;
      this.rejectedComment = null;
      this.rejectedFunctions.length = 0;
      this.blue_reject_note = null;
      this.red_reject_note = null;
      this.green_reject_note = null;
      this.black_reject_note = null;
      this.orange_reject_note = null;
    },
    rejFuncClass(data, face) {
      if (this.rejectedFunctions.length !== 0) {
        for (let i = 0; i <= this.rejectedFunctions.length; i++) {
          if (this.rejectedFunctions[i] && this.rejectedFunctions[i][0] === face) {
            if (this.rejectedFunctions[i][1].includes(data)) {
              return 'rejected-functions-true'
            }
          }
        }
      }
    },
    getClass(data) {
      if (this.user === data) {
        return 'right';
      } else {
        return 'left';
      }
    },
    getRejectedFunctionsList(functions) {
      let funcList = [];
      // let replaced = functions.replace(';0:', '; Total Order:')
      let arr = functions.split(';')
      let newArr = [];

      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          if (!arr[i].includes(':')) {
            newArr[i - 1] += ', ' + arr[i];
          } else {
            newArr[i] = arr[i]
          }
        }
      }

      for (let item of newArr) {
        let oneItem = {};
        if (typeof item === 'string' && item !== '' && item.includes(':')) {
          let arrItem = item.split(':');
          let keyItem = arrItem[0].trim() == 0 ? 'Total order' : 'Face ' + arrItem[0].trim();
          let value = arrItem[1].trim();
          oneItem[keyItem] = value;
          funcList.push(oneItem)
        }
      }
      return funcList;
      if (functions ) {
        let funcList = [];
        // let replaced = functions.replace(';0:', '; Total Order:')
        let arr = functions.split(';')
        let newArr = [];
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] !== '') {
            if (!arr[i].includes(':')) {
              newArr[i - 1] += ', ' + arr[i];
            } else {
              newArr[i] = arr[i]
            }
          }
        }
        for (let item of newArr) {

          let oneItem = {};
          if (typeof item === 'string' && item !== '' && item.includes(':')) {
            let arrItem = item.split(':');
            let keyItem = arrItem[0].trim() == 0 ? 'Total order' : 'Face ' + arrItem[0].trim();
            let value = arrItem[1].trim();
            oneItem[keyItem] = value;
            funcList.push(oneItem)
          }
        }
        return funcList;
      }
    },
    showPhotoDialog(url) {
      let redoneUrl = '';
      if (url && typeof (url) === 'string') {
        redoneUrl = url.replace('dl=0', 'raw=1');
      }
      this.modal_photo = (url && redoneUrl !== '') ? redoneUrl : '/img/images.png';
      this.showDialog10 = true;
    },
    getAllEmails() {
      this.sanitizeChat();
      let emails = this.order_chat.map((message) => {
        return message['email'];
      });
      this.emails = emails.filter((value, index, array) => {
        return array.indexOf(value) === index;
      });
    },
    getColor(email) {
      let key = this.emails.indexOf(email);
      return logo_colors[key + 1];
    },
    scrollChat2Bottom(){
//       let el = document.getElementById("chat_scroll_panel");
//       setTimeout(function() {
//         el.scrollTop = el.scrollHeight;
//       }, 0);
      let elements = document.querySelectorAll('.chat_scroll_panel');
      elements.forEach(function(el) {
        setTimeout(function() {
          el.scrollTop = el.scrollHeight;
        }, 0);
      });
    },
    // this function is for chats that sored as object of objects instead of array of objects
    sanitizeChat(){
      if (!Array.isArray(this.order_chat)) {
        if (typeof this.order_chat == 'object') {
          let result = Object.keys(this.order_chat).map((key) => this.order_chat[key]);
          this.order_chat = result;
        } else {
          this.order_chat = [];
        }
      }
    },
    getChatDivided() {
      this.order_chat_divided = [];
      this.sanitizeChat();
      let temp_date = '';
      this.order_chat_divided = this.order_chat.map((message) => {
        if (temp_date != message['date']) {
          temp_date = message['date'];
          let d = new Date(temp_date);
          let lang =  this.local_page_keys['language_short_name'] !== 'ua' ? this.local_page_keys['language_short_name'] : 'uk';
          let ye = new Intl.DateTimeFormat(lang, {year: 'numeric'}).format(d);
          let mo = new Intl.DateTimeFormat(lang, {month: 'long'}).format(d);
          let da = new Intl.DateTimeFormat(lang, {day: '2-digit'}).format(d);
          let wd = new Intl.DateTimeFormat(lang, {weekday: 'long'}).format(d);
          let date_str = 'unknown date';
          if (d.getFullYear() == ye) {
            date_str = `${wd}, ${da} ${mo}`;
          } else {
            date_str = `${wd}, ${da} ${mo} ${ye}`;
          }
          message['date_divider'] = date_str;
          return message;
        } else {
          return message;
        }
      });

    },
    getLike(likes) {
      if (( this.role === 'retoucher' || this.role === 'junior-retoucher') && likes < 4 && !this.isFromRetocherProgressReport) {
        return false
      }
      return likes;
    },
    async saveVersionRating(rate, message, function_name,face) {
      if ( typeof message.allowRate !== 'undefined' && !message.allowRate)
        return;

      let formData = new FormData();
      let version = this.getAfterPhotoVerNumber(message.link_text_non_secure);
      formData.append('order_id', this.order_id);
      formData.append('rate', rate);
      formData.append('version', version);
      formData.append('rater_role', this.role);
      formData.append('retoucher_email', message.email);
      formData.append('function', function_name);
      formData.append('face', face);
      try {
        await this.$store.dispatch("chat/saveVersionRating", {data: formData});
        let data = await this.$store.getters['chat/saveVersionRating'];
        // console.log(data)
        if (data.status === 'ok') {
          //set class active + loader
          this.setActiveRate(rate, function_name + '_' + face,version);
          if (!this.proRetoucherFirstRate.includes(function_name + '_' + face)) {
            this.proRetoucherFirstRate.push(function_name + '_' + face);
          }
          this.validateRatingForProRetoucher('save')
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert('Error rate', e)
      }
    },
    setActiveRate(rate, function_name,version) {
      const maxX = 5;
      for (let x = 1; x <= maxX; x++) {
        const elementId = `rate_${x}_${function_name}_${version}`;
        const element = document.getElementById(elementId);
        if (element) {
          element.classList.remove(activeClass);
        }
      }
      const rateElement = document.getElementById('rate_' + rate + '_' + function_name + '_' + version);
      if (rateElement) {
        rateElement.classList.add(activeClass);
      }
    },
    getVersionRateClass(rate, message, function_name, face) {
      let className = ''; // на будушее для дефолтных оценок
      let dataRates = message.functionRatings;
      //let version = this.getAfterPhotoVerNumber(message.link_text);
      if (dataRates) {
        let name = function_name + '_' + face;
        let result = dataRates.find(item => item.function === name && item.rate === rate)
        if (result) {
          className = activeClass;
        }
      }
      return className;
    },
    getVersionRateData(ratingsFunction, function_name, face) {
      let data = {
        color: null,
        icon: null,
        tooltip: null
      };
      let dataRates = ratingsFunction;
      if (dataRates) {
        let result = dataRates.ratings.find(item => item.function === function_name && item.face === Number(face))
        if (result) {
          data = this.fieldsRatingsBlockAllData.find(item => item.rate === result.rate)
        }
      }
      return data;
    },
    initFieldsRatingsBlockData(){
      let data = [
        {
          rate: 1,
          icon: 'sentiment_very_dissatisfied',
          tooltip: this.local_page_keys.rating_bad,
          color: 'red'
        },
        {
          rate: 2,
          icon: 'sentiment_neutral',
          tooltip: this.local_page_keys.rating_normal,
          color: 'orange'
        },
        {
          rate: 3,
          icon: 'sentiment_satisfied',
          tooltip: this.local_page_keys.rating_good,
          color: 'yellow'
        },
        {
          rate: 4,
          icon: 'mood',
          tooltip: this.local_page_keys.rating_excellent,
          color: 'green'
        },
        {
          rate: 5,
          icon: 'help',
          tooltip: this.local_page_keys.rating_dont_know,
          color: 'gray'
        }
      ];

      this.fieldsRatingsBlockAllData = data;

      if(this.role !== 'pro-retoucher') {
        data = data.filter(item => item.rate !== 5);
      }

      this.fieldsRatingsBlockData = data;

    },
    prepareText(text) {
      function replaceTextWithLink(text) {
        const linkRegex = /https:\/\/\S+/g;
        return text.replace(linkRegex, (match) => {
          return `<a href="${match}" target="_blank">${match}</a>`;
        });
      }

      return this.deleteEmail(replaceTextWithLink(text));
    },
    deleteEmail(text) {
      if (['retoucher', 'junior-retoucher', 'test-retoucher'].indexOf(this.role) > -1) {
        let emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
        return text.replace(emailRegex, (match) => {
          if (text.includes(`(${match})`)) {
            return '';
          } else {
            return match;
          }
        }).replace(/\s*\(|\s*\)/g, '');
      }
      return text;
    },
    validateRatingForProRetoucher(source) {
      this.requiredRateProRetoucher = [];
      if (this.role !== 'pro-retoucher')
        return;

      if (source === 'action')
        this.enableValidate = true;

      if (!this.enableValidate)
        return;

      //Работает только для проретушера для условия, что он может голосовать только за первую версию
      const isAllowRate = this.order_chat.some(item => item.allowRate === true);
      const rateFaces = this.proRetoucherFirstRate;
      const facesKeys = [];

      if (!isAllowRate)
        return true;

      //если до этого была оценка
      this.order_chat.forEach(data => {
        if (data.version === 1 && data.allowRate) {
          data.functionRatings.forEach(item => {
            if (!this.proRetoucherFirstRate.includes(item.function)) {
              this.proRetoucherFirstRate.push(item.function);
            }
          });
        }
      });

      for (const value of Object.keys(this.faces)) {
        for (const faceValue of Object.keys(this.faces[value])) {
          if (faceValue !== 'order_super_function' && faceValue !== 'order_silver_super_function' && faceValue !== 'order_subscription_super_function' && this.faces[value][faceValue].RU) {
            facesKeys.push(faceValue + '_' +value);
          }
        }
      }

      rateFaces.sort();
      facesKeys.sort();

      this.isValidateProRetoucherRating = rateFaces.length === facesKeys.length && rateFaces.every((value, index) => value === facesKeys[index]);

      if (!this.isValidateProRetoucherRating) {
        for (const element of facesKeys) {
          if (!rateFaces.includes(element)) {
            this.requiredRateProRetoucher.push(element);
          }
        }
      }

      return this.isValidateProRetoucherRating;
    },
    validateFace(face) {
      if(this.role !== 'pro-retoucher')
        return true;

      if (!this.isValidateProRetoucherRating) {
          if (this.requiredRateProRetoucher.includes(face)) {
              return false;
          }
      }
      return true;
    },
    filterMessageStatusRejected(message) {
      if (message) {
        let ignoreMessage = ['Не достаточно профессионально'];
        if (!ignoreMessage.some(ignored => message.includes(ignored))) {
          return message;
        }
      }
    },
    getDatesOfViewedVersion(versions){
      let message = "";
      for (let i = 0; i <= versions.length; i++){
        if(versions[i] && versions[i].version_date){
          message += versions[i].version_date+"</br>";
        }
      }
      return message;
    },
    //фикс, Chrome не передает логин и пароль
    fixLinkFromClient(link){
      var originalLink = link;
      var condition = "@orders.fixthephoto.com";
      var replacementLink = "https://fdl.retoucher.app/integroget.php?at=Jw4i43bIs2GtHqxUdUP0aefUTjDMdtsWJ4ijlXfx5MYVMobt&action=get_file&fn=";
      if(originalLink.includes(condition)) {
        var fileName = originalLink.substring(originalLink.lastIndexOf('/') + 1);
        return  replacementLink + fileName;
      }
      return originalLink;
    },
    languageRuDetect(text){
      const regex = /[а-яё]/i;
      return regex.test(text);
    },
    setZoomLevel(level) {
      if (this.zoomLevels.includes(level)) {
        this.zoomLevelOld = this.zoomLevel;
        this.zoomLevel = level;
        if(this.zoomLevel !== this.zoomLevelOld){
          this.zoomLoading = true;
          this.zoomImageRatioErase();
          this.readAndPreviewZoomImage('fixedphoto');
          this.changeZoomStyle();
        }
      }
    },
    updateComputedValue() {
      this.$nextTick(() => {
        this.$forceUpdate(); // Force the component to re-render and update the computed property
      });
    },
    afterZoomInMethod(imageContainerClassFrom){
      let _this = this;

      const imageContainer = document.querySelector('.' + imageContainerClassFrom);

      if (imageContainer) {
        const childElement = imageContainer.querySelector('.iiz__zoom-img');

        if (
            childElement.classList.contains('iiz__zoom-img') &&
            childElement.classList.contains('iiz__zoom-img--visible')
        ) {
          _this.observedZoomedElementStyle = childElement.style.cssText;

        }
      }
    },
    zoomImageRatioErase(){
      for( const zoomLevel of this.zoomLevels){
        if('zoom_' + zoomLevel in window){
          if('imgHeight' in window['zoom_' + zoomLevel]){
            delete window['zoom_' + zoomLevel].imgHeight;
          }
          if('imgWidth' in window['zoom_' + zoomLevel]){
            delete  window['zoom_' + zoomLevel].imgWidth ;
          }
        }
      }
    },
    async readAndPreviewZoomImage(main_photo_option){
      let largerImageData; // Declare a global variable
      let _this = this;
      function getFourTimesLargerImageDataFromURL(imageURL, scale = 2) {
        return new Promise((resolve, reject) => {
          //const scale = 2; // Scale factor to make the image four times larger

          const desiredHeight = 900;
          const img = new Image();
          img.crossOrigin = "Anonymous"; // Enable cross-origin requests if necessary
          img.onload = function() {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            // Calculate the new dimensions while maintaining the aspect ratio
            let newWidth = img.width * scale;
            let newHeight = img.height * scale;
            if(newHeight > desiredHeight * scale){
              newWidth = newWidth * (desiredHeight * scale / newHeight);
              newHeight = desiredHeight * scale;
              img.width = newWidth;
              img.height = newHeight;
            } else {
              newWidth = newWidth * (desiredHeight * scale / newHeight);
              newHeight = desiredHeight * scale;
              img.width = newWidth;
              img.height = desiredHeight * scale ;
            }
            if(!('zoom_' + scale in window)){
              window['zoom_' + scale] = {};
            }
            if(!('zoom_' + scale in window && 'imgHeight' in window['zoom_' + scale])) {
              window['zoom_' + scale].imgHeight = img.height;
              window['zoom_' + scale].imgWidth = img.width;
            }
            if('zoom_' + scale in window && 'imgHeight' in window['zoom_' + scale]){
              let scaleFactorHeight = window['zoom_' + scale].imgHeight / img.height;
              let scaleFactorWidth = window['zoom_' + scale].imgWidth / img.width;
              newHeight = img.height * scaleFactorHeight;
              newWidth = img.width * scaleFactorWidth;
            }
            canvas.width = newWidth;
            canvas.height = newHeight;
            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            largerImageData = canvas.toDataURL("image/jpeg"); // Assign to the global variable
            if(largerImageData.length > 6){
              resolve(largerImageData);
            } else {
              largerImageData = imageURL;
              reject(largerImageData);
            }
          };
          img.onerror = function() {
            //console.error("Error loading the image.");
            reject("Failed to fetch the larger image data.");
          };
          img.src = imageURL;
        });
      }

      const imageUrl = this[main_photo_option];

      largerImageData = getFourTimesLargerImageDataFromURL(imageUrl, this.zoomLevel)
          .then(largerImage => {
            if (largerImage) {
              // The largerImageData variable contains the Base64-encoded larger image data

              _this[main_photo_option + '_zoomed'] = largerImage;
              //console.log("Larger Image data:", largerImageData);

            } else {
              //console.log("Failed to fetch the larger image data.");
              alert("Failed to fetch the larger image data.")
            }
          })
          .catch(error => {
            //console.error(error);
            _this[main_photo_option + '_zoomed'] = error;
            //alert(JSON.stringify(error));
          });

      //console.log(main_photo_option + '_zoomed', _this[main_photo_option + '_zoomed']);
    },
    changeZoomStyle() {
      const imageContainer = document.querySelector('.' + 'fixedphoto_zoomed');
      let levelSwitchedOnZoom = false;
      let observedZoomedElementStyle = this.observedZoomedElementStyle;
      if (imageContainer) {
        const childElement = imageContainer.querySelector('.iiz__zoom-img');

        if (
            childElement.classList.contains('iiz__zoom-img') &&
            childElement.classList.contains('iiz__zoom-img--visible')
        ) {
          levelSwitchedOnZoom = true;
        }
      }

      this.$nextTick(() => {
        if(levelSwitchedOnZoom){
          for(const imageContainerClassTo of ['fixedphoto_zoomed']) {
            const imageContainerZoomed = document.querySelector('.' + imageContainerClassTo);
            if (imageContainerZoomed) {
              const imgElementZoomedTo = imageContainerZoomed.querySelector('.iiz__zoom-img');
              const imgElementTo = imageContainerZoomed.querySelector('.iiz__img');
              if (imgElementZoomedTo) {
                if (!imgElementZoomedTo.classList.contains("iiz__zoom-img--visible")) {
                  imgElementZoomedTo.classList.add("iiz__zoom-img--visible");
                }

                let observedZoomedElementStyleObj = this.parseStyleToObject(this.observedZoomedElementStyle);
                let zoomLevel = this.zoomLevel;
                let zoomLevelOld = this.zoomLevelOld;
                let scaleFactor = (zoomLevel / zoomLevelOld);
                let maxTop = (-1) * (zoomLevel - 1) * 900;
                observedZoomedElementStyleObj.top = parseInt(observedZoomedElementStyleObj.top, 10) * scaleFactor;
                if (observedZoomedElementStyleObj.top < maxTop) observedZoomedElementStyleObj.top = maxTop;
                observedZoomedElementStyleObj.top = observedZoomedElementStyleObj.top + 'px';
                observedZoomedElementStyleObj.left = parseInt(observedZoomedElementStyleObj.left, 10) * scaleFactor + 'px';
                this.observedZoomedElementStyle = this.combineObjectToStyle(observedZoomedElementStyleObj);

                imgElementZoomedTo.style = this.observedZoomedElementStyle;
              }
              if (imgElementTo) {
                if (!imgElementTo.classList.contains("iiz__img--hidden")) {
                  imgElementTo.classList.add("iiz__img--hidden");
                }
              }
            }
          }
        }
        this.zoomLoading = false;
      });
    },
    parseStyleToObject(styleString) {
      let styleObject = {};
      let stylePairs = styleString.split(';');
      stylePairs.forEach(function(pair) {
        let parts = pair.trim().split(':');
        if (parts.length === 2) {
          styleObject[parts[0].trim()] = parts[1].trim();
        }
      });
      return styleObject;
    },
    combineObjectToStyle(styleObject) {
      let styleString = '';
      for (let key in styleObject) {
        if (styleObject.hasOwnProperty(key)) {
          styleString += key + ': ' + styleObject[key] + '; ';
        }
      }
      return styleString.trim();
    },
  },
  async created() {
    await  this.$store.dispatch('chat/setSelectedProRetoucher', null);
    await  this.$store.dispatch('chat/setSelectedRetoucher', null);
    this.local_page_keys = await getLocalisationPage('order-historyBlock');
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('order-orderCheck'), await this.$filtergetLocalisationPage('order-historyBlock'), await this.$filtergetLocalisationPage('ru_retoucher_translations'));
    this.initFieldsRatingsBlockData();
    this.getAllEmails();
    this.getChatDivided();
    this.scrollChat2Bottom();
    this.zoomImageRatioErase();

  },
}
</script>
<style>
.tm-chat-version-grade .uk-accordion-title {
  font-size: 12px;
  line-height: 1;
}

.tm-chat-version-grade .uk-accordion-title:hover {
  color: #666 !important;
}

.tm-chat-version-grade .uk-accordion-title:focus {
  color: #333 !important;
}

.uk-accordion.tm-chat-version-grade {
  padding: 5px;
  background-color: #fbfbfb;
  border-radius: 3px 3px 0 3px;
  margin-bottom: 15px;
}

.tm-chat-version-grade .uk-accordion-content {
  margin-top: 15px;
}

.tm-chat-version-grade-button {
  border-radius: 3px;
  padding: 3px;
  display: block;
  cursor: pointer;
}

.tm-chat-version-grade-button .md-icon,
.tm-chat-version-grade-button {
  transition: 0.1s ease-in-out;
  font-size: 20px !important;
  line-height: 1;
}

.tm-chat-version-grade-button-red .md-icon,
  .tm-chat-version-grade-grid > div:nth-child(1) .tm-chat-version-grade-button .md-icon {
  color: #f44336;
}
  .tm-chat-version-grade-button-checked.tm-chat-version-grade-button-red,
.tm-chat-version-grade-grid > div:nth-child(1) .tm-chat-version-grade-button-checked,
.tm-chat-version-grade-grid > div:nth-child(1) .tm-chat-version-grade-button:hover {
  background-color: #f44336;
}

.tm-chat-version-grade-button-orange .md-icon,
  .tm-chat-version-grade-grid > div:nth-child(2) .tm-chat-version-grade-button .md-icon {
  color: #fb8c00;
}

.tm-chat-version-grade-button-checked.tm-chat-version-grade-button-orange,
.tm-chat-version-grade-grid > div:nth-child(2) .tm-chat-version-grade-button-checked,
.tm-chat-version-grade-grid > div:nth-child(2) .tm-chat-version-grade-button:hover {
  background-color: #fb8c00;
}

.tm-chat-version-grade-button-yellow .md-icon,
.tm-chat-version-grade-grid > div:nth-child(3) .tm-chat-version-grade-button .md-icon {
  color: #ffd400;
}

.tm-chat-version-grade-button-checked.tm-chat-version-grade-button-yellow,
.tm-chat-version-grade-grid > div:nth-child(3) .tm-chat-version-grade-button-checked,
.tm-chat-version-grade-grid > div:nth-child(3) .tm-chat-version-grade-button:hover {
  background-color: #ffd400;
}

.tm-chat-version-grade-button-green .md-icon,
  .tm-chat-version-grade-grid > div:nth-child(4) .tm-chat-version-grade-button .md-icon {
  color: #4caf50;
}

.tm-chat-version-grade-button-checked.tm-chat-version-grade-button-green,
.tm-chat-version-grade-grid > div:nth-child(4) .tm-chat-version-grade-button-checked,
.tm-chat-version-grade-grid > div:nth-child(4) .tm-chat-version-grade-button:hover {
  background-color: #4caf50;
}

.tm-chat-version-grade-button-checked.tm-chat-version-grade-button-gray,
.tm-chat-version-grade-grid > div:nth-child(5) .tm-chat-version-grade-button-checked,
.tm-chat-version-grade-grid > div:nth-child(5) .tm-chat-version-grade-button:hover {
  background-color: #b1b1b1;
}

.tm-chat-version-grade-button-checked .md-icon,
.tm-chat-version-grade-button:hover .md-icon {
  color: #fff !important;
}

.tm-chat-version-grade-button-label input {
  display: none;
}

.uk-button.tm-chat-version-grade-button-collapse-all {
  padding: 0 10px;
  line-height: 1;
  text-transform: none;
  font-size: 12px;
  font-weight: normal;
  margin-bottom: 15px;
  border-radius: 0 0 3px 3px;
}

.uk-button.tm-chat-version-grade-button-collapse-all > .md-icon {
  font-size: 20px !important;
  width: 20px;
  min-width: 20px;
  height: 20px;
}

.tm-chat-version-graded .tm-chat-box-name {
  padding: 0 3px;
  width: 21px;
  height: 21px;
  line-height: 21px;
  min-width: 21px;
  border-radius: 10px;
  width: auto;
}

.tm-chat-version-graded-button .md-icon {
  font-size: 21px !important;
}

.tm-chat-box-line.tm-chat-box-line-error::before {
  border-bottom-color: #f44336;
}

.tm-chat-box-line.tm-chat-box-line-error > div {
  background-color: #f44336;
}

.tm-chat-box-line.tm-chat-box-line-error .tm-chat-box-file2 {
  color: #fff;
}

.tm-function-order-error {
  border: 1px solid red;
  padding: 4px;
  border-radius: 3px;
}
.tm-animation-pulse {
  transition: all 400ms cubic-bezier(.175,.885,.32,1.1);
  position: relative;
}
.tm-animation-pulse::before,
.tm-animation-pulse::after {
  content: '';
  position: absolute;
  border: #4caf50 solid 3px;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  top: -3px;
  left: -3px;
  bottom: -3px;
  right: -3px;
  margin: auto;
  opacity: 0;
}
.tm-animation-pulse {
  animation: scale 3s cubic-bezier(0.175, 0.885, 0.32, 1.3);
}
.tm-animation-pulse:before,
.tm-animation-pulse:after {
  animation: pulse 3s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  animation-delay: 400ms;
}
.tm-animation-pulse:before {
  animation-delay: 600ms;
}
@keyframes scale {
  0%, 15% {
    transform: scale(1);
  }
  5%, 10% {
    transform: scale(1.1);
  }
}
@keyframes pulse {
  0% {
    opacity: .3;
    background-color: rgba(76, 175, 80, .5);
    transform: scale(1);
  }
  50% {
    opacity: 0;
    background-color: rgba(76, 175, 80, 0);
    transform: scale(1.3, 1.7);
  }
}
</style>